/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { CombinedCompositeVisitor } from '../../combined/visitors/CombinedCompositeVisitor';
import { Document } from '../models/Document';
import { Node } from '../models/Node';
import { NodePath } from '../models/NodePath';
import { ValidationProblem } from '../models/ValidationProblem';
import { ValidationProblemSeverity } from '../models/ValidationProblemSeverity';
import { NodePathUtil } from '../util/NodePathUtil';
import { IValidationProblemReporter } from './IValidationProblemReporter';
import { IValidationSeverityRegistry } from './IValidationSeverityRegistry';
import { ValidationRuleSet } from './ValidationRuleSet';
import { ValidationRule } from './ValidationRule';
import { ValidationRuleMetaData } from './ValidationRuleMetaData';

/**
 * Constructor.
 * @param {Document} document
 * @class
 * @extends CombinedCompositeVisitor
 * @author eric.wittmann@gmail.com
 */
export class ValidationVisitor extends CombinedCompositeVisitor implements IValidationProblemReporter {
    /*private*/ problems : Array<ValidationProblem> = <any>([]);

    /*private*/ severityRegistry : IValidationSeverityRegistry;

    public constructor(document : Document) {
        super(<any>([]));
        if(this.severityRegistry===undefined) this.severityRegistry = null;
        let ruleSet : ValidationRuleSet = ValidationRuleSet.instance_$LI$();
        let rulesFor : Array<ValidationRule> = ruleSet.getRulesFor(document);
        rulesFor.forEach((rule) => {
            rule.setReporter(this);
        });
        this.addVisitors(rulesFor);
    }

    /**
     * Sets the severity registry.
     * @param {*} severityRegistry
     */
    public setSeverityRegistry(severityRegistry : IValidationSeverityRegistry) {
        this.severityRegistry = severityRegistry;
    }

    /**
     * Accessor for the problems.
     * @return {ValidationProblem[]}
     */
    public getValidationProblems() : Array<ValidationProblem> {
        return this.problems;
    }

    /**
     * @see io.apicurio.datamodels.core.validation.IValidationProblemReporter#report(io.apicurio.datamodels.core.validation.ValidationRuleMetaData, io.apicurio.datamodels.core.models.Node, java.lang.String, java.lang.String)
     * @param {ValidationRuleMetaData} ruleInfo
     * @param {Node} node
     * @param {string} property
     * @param {string} message
     */
    public report(ruleInfo : ValidationRuleMetaData, node : Node, property : string, message : string) {
        let severity : ValidationProblemSeverity = this.severityRegistry.lookupSeverity(ruleInfo);
        if(severity === ValidationProblemSeverity.ignore) {
            return;
        }
        let path : NodePath = NodePathUtil.createNodePath(node);
        let problem : ValidationProblem = node.addValidationProblem(ruleInfo.code, path, property, message, severity);
        /* add */(this.problems.push(problem)>0);
    }
}
ValidationVisitor["__class"] = "io.apicurio.datamodels.core.validation.ValidationVisitor";
ValidationVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.core.validation.IValidationProblemReporter","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




